import { type AssignmentMatrixView, type TeamWorkloadView } from '@apm/contracts';
import { apiFetch } from '../../lib/http';

export const coordinationApi = {
  teamWorkload: (projectId: string, from: string, to: string) =>
    apiFetch<TeamWorkloadView>(`/projects/${projectId}/workload?from=${from}&to=${to}`),

  assignmentMatrix: (projectId: string) =>
    apiFetch<AssignmentMatrixView>(`/projects/${projectId}/assignment-matrix`),
};

export const coordinationKeys = {
  teamWorkload: (projectId: string, from: string, to: string) =>
    ['coordination', 'workload', projectId, from, to] as const,
  assignmentMatrix: (projectId: string) => ['coordination', 'matrix', projectId] as const,
};
